// extracted by mini-css-extract-plugin
export default {"nonIdealContainer":"styles_nonIdealContainer__y6huE","title":"styles_title__wBBzn","subTitle":"styles_subTitle__b3PYv","actionButtons":"styles_actionButtons__2A2RR"};